<template>
  <div :class="sizes[size]" data-qa="priceCurrent">
    {{ price }}
  </div>
</template>

<script setup lang="ts">
import { tw } from '@backmarket/utils/string/tw'

import { type PriceProps } from './types'

// Sizes are completely arbitrary and might need revision
const sizes = {
  small: tw`text-[1.6rem]`,
  medium: tw`text-[1.7rem]`,
  large: tw`text-[2.4rem]`,
}

withDefaults(defineProps<PriceProps>(), {})
</script>
